"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var initialState = {
  gates: []
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _ActionTypes.INITIALIZE_AUTH:
      return {
        user: payload.user,
        gates: payload.gates,
        portal: payload.portal
      };

    default:
      return state;
  }
};

var _default = auth;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Auth.js
// module id = 518
// module chunks = 5 6